// extracted by mini-css-extract-plugin
export default {"picker":"picker___y6hqR","body":"body___Aj3M0","footer":"footer___HSdTG"};